import axios from './axiosInstance';

export function getNotifications(page) {
    return axios.get(`/notifications?page=${page}`);
}

export function postNotifications(notification) {
    return axios.post('/notifications', {...notification});
}